fragment WorkgroupGroupFields on WorkgroupGroup {
  id
  name
  description
  _isActive
  _isUpdatable
  _isDeletable
  _isModified
  _rowTimestamp

  workgroupGroupItems(orderBy: CORPORATE_WORKGROUP_BY_WORKGROUP_ID__NAME_ASC) {
    nodes {
      id
      workgroupId
      corporateWorkgroup {
        name
      }
      _rowTimestamp
    }
  }
}
